<template>
  <Input :model-value="local" @update:model-value="onChange" />
</template>

<script>
import { Input } from "@/shared/ui/input";

export default {
  components: { Input },
  props: ["item"],
  data() {
    return { local: this.item.value ?? "" };
  },
  watch: {
    "item.value"(val) {
      if (val !== this.local) this.local = val ?? "";
    },
  },
  methods: {
    onChange(val) {
      this.local = val ?? "";
      this.$emit("update", this.item.key, val ? val : null);
    },
  },
};
</script>
